import React from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { ShareLogo, ShareType, SharingLink } from '../types';
import { StyledLogo } from './styles';

type ShareButtonProps = {
  logo: ShareLogo;
  link: SharingLink;
} & ComponentProps;

const ShareButton: React.FC<ShareButtonProps> = ({ logo, link }) => {
  const emailOnClick = (event: React.MouseEvent, mailtoLink: string): void => {
    if (logo.onClick) {
      logo.onClick(event);
    }
    window.location.href = mailtoLink;
  };

  switch (logo.shareType) {
    case ShareType.EMAIL:
      return (
        <EmailShareButton
          onClick={emailOnClick}
          url={link.url}
          subject={link.title}
          body={link.description}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </EmailShareButton>
      );
    case ShareType.FACEBOOK:
      return (
        <FacebookShareButton onClick={logo.onClick} url={link.url}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </FacebookShareButton>
      );
    case ShareType.TWITTER:
      return (
        <TwitterShareButton onClick={logo.onClick} url={link.url} title={link.title}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </TwitterShareButton>
      );
    case ShareType.WHATSAPP:
      return (
        <WhatsappShareButton onClick={logo.onClick} url={link.url} title={link.title}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </WhatsappShareButton>
      );
    case ShareType.LINKEDIN:
      return (
        <LinkedinShareButton
          onClick={logo.onClick}
          url={link.url}
          title={link.title}
          summary={link.description}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </LinkedinShareButton>
      );
    case ShareType.PINTEREST:
      return link.image ? (
        <PinterestShareButton
          onClick={logo.onClick}
          url={link.url}
          media={link.image}
          description={link.description}>
          <StyledLogo src={logo.image.url} alt={logo.image.altText} focusable={false} />
        </PinterestShareButton>
      ) : null;
    default:
      return null;
  }
};

export default applyComponentTheme(ShareButton, 'ShareButton');
